const debug = true;

export default debug;
